// PDF brand colors used by behumanPdfGenerator
export const BRAND_BLUE = '#1a5276'
export const HEADER_BG = '#f0f4f8'
export const BORDER_COLOR = '#d0d7de'
export const TEXT_SECONDARY = '#444'
export const TABLE_LINE_COLOR = '#e8e8e8'

// Supervising physician printed beneath the ordering practitioner on every order.
// Many facilities require a supervising physician's name (and NPI) even when an NP/RN places the order.
export const SUPERVISING_PHYSICIAN_NAME = 'Inna Yaskin, DO'
export const SUPERVISING_PHYSICIAN_NPI = '1316965353'
